import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function Team({ member }) {
  return (

    <ValueItem
      icon="team-icon"
      label="Team"
    >
      {member.team}
    </ValueItem>
  );
}

Team.propTypes = {
  member: PropTypes.object.isRequired,
};
